import React from "react";
import { Avatar } from "antd";
import {
  DisputeCard as StyledDisputeCard,
  DisputeCardHeader,
  DisputeCardHeaderContent,
  DisputeCardContent,
  DisputeTitle,
  DisputeDescription,
  DisputeCardFooter,
  StatusTag,
} from "./styles";
import { DisputeCardProps } from "./types";

const DisputeCard: React.FC<DisputeCardProps> = ({
  dispute,
  onOpen,
  setSelectedDispute,
}) => {
  const handleClick = () => {
    setSelectedDispute(dispute);
    onOpen();
  };

  return (
    <StyledDisputeCard onClick={handleClick}>
      <DisputeCardHeader>
        <Avatar size="large">
          {dispute.customerName.charAt(0).toUpperCase()}
        </Avatar>
        <DisputeCardHeaderContent direction="vertical" size={0}>
          <DisputeTitle strong>{dispute.customerName}</DisputeTitle>
          <DisputeDescription type="secondary">
            ID: {dispute.id}
          </DisputeDescription>
        </DisputeCardHeaderContent>
      </DisputeCardHeader>

      <DisputeCardContent>
        <DisputeTitle>{dispute.title}</DisputeTitle>
        <DisputeDescription>{dispute.description}</DisputeDescription>
      </DisputeCardContent>

      <DisputeCardFooter>
        <StatusTag status={dispute.status}>{dispute.status}</StatusTag>
      </DisputeCardFooter>
    </StyledDisputeCard>
  );
};

export default DisputeCard;
